import React from 'react'
import {
    StyledTWStaticAFLCard,
    StyledTWStaticAFLCardText,
    StyledTWStaticAFLCardHeading,
    StyledWeAreForAFLLogo,
    StyledTWStaticAFLCardTextWrapper,
} from './TWStaticAFLCard.styled'
import { colors } from 'component-library/__styling/settings'

export const TWStaticAFLCard = () => {
    return (
        <StyledTWStaticAFLCard>
            <StyledTWStaticAFLCardTextWrapper>
                <StyledTWStaticAFLCardHeading>
                    Who are WA's top draft prospects?
                </StyledTWStaticAFLCardHeading>
                <StyledTWStaticAFLCardText>
                    See video highlights, stats and profiles for our 20 leading draftee contenders.
                </StyledTWStaticAFLCardText>
            </StyledTWStaticAFLCardTextWrapper>
            <StyledWeAreForAFLLogo fill={colors.white} />
        </StyledTWStaticAFLCard>
    )
}
